module.exports = __webpack_public_path__ + "img/product_37.70422ba.webp";